import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import erro from "../imagem/erro.svg";
import "./ErroNaOperacao.css";

function ErroNaOperacao({ abrirModal, fecharModal, text }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openModalConf, setOpenModalConf] = useState(false);


  function openModal() {
    handleOpen();
    setTimeout(() => {
      setOpenModalConf(false);
    }, 4000);
  }

  return (
    <>
      {abrirModal && (
        <div>
          <Modal
            open={abrirModal}
            onClose={fecharModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "var(--cor-branco)",
                boxShadow: "1.5rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                p: 4,
                width: "auto",
                height: "auto",
                opacity: 1,
                borderRadius: "1.5rem",
                gap: 3,
              }}
            >
              <img src={erro} className="img_erro" />

              <Typography
                variant="h6"
                component="h2"
                sx={{
                  fontWeight: 700,
                  fontSize: "1.375rem",
                  lineHeight: "100%",
                }}
              >
                Erro na operação
              </Typography>

              <Typography
                sx={{
                  color: "rgba(140, 140, 140, 1)",
                }}
              >
                {text}
              </Typography>
            </Box>
          </Modal>
        </div>
      )}
    </>
  );
}

export default ErroNaOperacao;
